import { render } from "./LoadingAnim.vue?vue&type=template&id=4961a018&scoped=true"
const script = {}

import "./LoadingAnim.vue?vue&type=style&index=0&id=4961a018&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4961a018"]])

export default __exports__